import React, { useContext, useState } from "react";
import { DataContext } from "../../index";
import { TiTick } from "react-icons/ti";

export const SidebarSection = () => {
  const counterState = useContext(DataContext);
  let {
    displayedSidebar,
    sidebarData,
    liData,
    getLiData,
    selectValue,
    setSelectValue,
    clickData,
  } = counterState;
  // console.log("CounterState",count);


  return (
    <div className="w-[550px]">
      <div className="col-md-2 p-0 sidebar_scroll_section">
        <div className="cal-step-list">
          <ul className="nav nav-tabs" id="myTabs">
            {displayedSidebar.map((value) => {
              return value.id <= liData ? (
                <li className="nav-item" onClick={() => getLiData(value.id)}>
                  <a
                    className={`${value.id == liData ? "active" : ""} nav-link`}
                    id="tabStep1"
                    data-toggle="tab"
                    href="#stepNew1"
                  >
                    <span>{value.id < liData ? <TiTick /> : value.id}</span>
                    <span>
                      <h5>{value.heading}</h5>
                      <h6>{value.subHeading}</h6>
                    </span>
                  </a>
                </li>
              ) : (
                <li className="nav-item">
                  <a
                    className={`nav-link !cursor-auto`}
                    id="tabStep1"
                    data-toggle="tab"
                    href="#stepNew1"
                    onClick={
                      (selectValue.section1 != null && value.id == 1) ||
                      (selectValue.section2 != null && value.id == 2) ||
                      (selectValue.section3 != null && value.id == 3) ||
                      (selectValue.section4 != null && value.id == 4) ||
                      (selectValue.section5 != null && value.id == 5) ||
                      (selectValue.section6 != null && value.id == 6) ||
                      (selectValue.section7 != null && value.id == 7) ||
                      (selectValue.section8 != null && value.id == 8)
                        ? () => getLiData(value.id)
                        : null
                    }
                  >
                    <span>{value.id < liData ? <TiTick /> : value.id}</span>
                    <span>
                      <h5>{value.heading}</h5>
                      <h6>{value.subHeading}</h6>
                    </span>
                  </a>
                </li>
              );
            })}
            {/* <li className="nav-item">
                                <a className="nav-link active" id="tabStep1" data-toggle="tab" href="#stepNew1">
                                    <span>1</span>
                                    <span>
                                        <h5>Printed Book Distribution</h5>
                                        <h6>Selection required</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep2" data-toggle="tab" href="#stepNew2">
                                    <span>2</span>
                                    <span>
                                        <h5>Text Formatting</h5>
                                        <h6>Selection required</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep3" data-toggle="tab" href="#stepNew3">
                                    <span>3</span>
                                    <span>
                                        <h5>Cover Design</h5>
                                        <h6>Selection required</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep4" data-toggle="tab" href="#stepNew4">
                                    <span>4</span>
                                    <span>
                                        <h5>ISBN – Printed Books</h5>
                                        <h6>Selection required</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep5" data-toggle="tab" href="#stepNew5">
                                    <span>5</span>
                                    <span>
                                        <h5>Recommended For You</h5>
                                        <h6>Selection(s) optional</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep6" data-toggle="tab" href="#stepNew6">
                                    <span>6</span>
                                    <span>
                                        <h5>Save Project</h5>
                                        <h6>Enter a quote name</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep7" data-toggle="tab" href="#stepNew7">
                                    <span>7</span>
                                    <span>
                                        <h5>Save Project</h5>
                                        <h6>Enter a quote name</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep8" data-toggle="tab" href="#stepNew8">
                                    <span>8</span>
                                    <span>
                                        <h5>Save Project</h5>
                                        <h6>Enter a quote name</h6>
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="tabStep9" data-toggle="tab" href="#stepNew9">
                                    <span>9</span>
                                    <span>
                                        <h5>Save Project</h5>
                                        <h6>Enter a quote name</h6>
                                    </span>
                                </a>
                            </li> */}
          </ul>
          {/* <button onClick={clickData}>Data</button> */}
        </div>
      </div>
    </div>
  );
};
